
import { Component, Vue } from "vue-property-decorator";
import QRCode from "qrcodejs2";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import FileUpload from "@/components/scope/file-upload.vue";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const service = namespace("service");
const user = namespace("user");
const finance = namespace("finance");
const app = namespace("app");

@Component({
  components: { FileUpload }
})
export default class MakeInvoice extends Vue {
  @service.Action createInvoice;
  @service.Action getInvoiceInfo;
  @service.Action getOrderDetail;
  @service.Action getInvoiceTitleList;
  @user.State selectedOrgCode;
  @user.Getter tenantCode;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @finance.Action getReceiptDetail;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  API_URL = window.API_URL;
  H5_SITE_URL = window.H5_SITE_URL;
  get breadData() {
    return this.$route.params.id.includes("SK")
      ? [{ name: t("finance.receipt"), path: `/finance/collection-order` }, { name: t("service.make-out-invoice") }]
      : [
          { name: t("test.service-management"), path: "/service/index" },
          { name: t("service.service-details"), path: `/service/view/${this.orderId}` },
          { name: t("service.make-out-invoice") }
        ];
  }
  get orderId() {
    return this.$route.params.id;
  }
  get isTmall() {
    return this.orderInfo.orderSource === "2";
  }
  lastInvoce: any = {
    titleName: "-"
  };
  orderInfo: any = {
    orderSource: "2"
  };
  selectedInvoiceTitleCode: string = "";
  selectedInvoiceTitleData: any = {};
  invoiceCompanyList: any = []; // 保存的开票公司信息
  invoiceFormData = {
    invoiceCategoryCode: "",
    invoiceNo: "",
    invoiceUrl: ""
  };
  invoiceFormRulesTmall = {
    invoiceCategoryCode: [{ required: true, message: t("service.enter-invoice-code"), trigger: "blur" }],
    invoiceNo: [{ required: true, message: t("service.enter-invoice-number"), trigger: "blur" }],
    invoiceUrl: [{ required: true, message: t("service.upload-invoice-picture"), trigger: "blur" }]
  };
  invoiceFormRulesOther = {};
  created() {
    if (this.getReceiptId.includes("SK")) {
      // 收款单开票订单来源设为null
      this.orderInfo.orderSource = null;
      this.getCollectionDetail();
    } else {
      this.init();
      console.log("0");
    }
    this.searchInvoiceCompany("");
  }
  get getReceiptId() {
    return this.$route.params.id;
  }
  collectionDetail: any = {};
  getCollectionDetail() {
    this.getReceiptDetail({
      receiptNo: this.getReceiptId,
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.collectionDetail = data.data;
      console.log("collectionDetail", data.data, this.orderInfo.receiptAmount);
    });
  }
  mounted() {
    setTimeout(() => {
      this.qrCode(`${this.H5_SITE_URL}/make-invoice?tenantCode=${this.tenantCode}&orgCode=${this.selectedOrgCode}`);
    }, 2000);
  }
  searchInvoiceCompany(val) {
    this.getInvoiceTitleList({
      pageNum: 1,
      pageSize: 10,
      searchKey: val
    }).then(data => {
      if (data.data.list) {
        this.invoiceCompanyList = data.data.list.map(item => {
          if (item.titleTaxId) {
            item.titleNameFull = `${item.titleName}/${item.titleTaxId}`;
          }
          return item;
        });
        if (!val) {
          // 没有关键字，才取最近一条
          this.lastInvoce = data.data.list[0] ? data.data.list[0] : {};
        }
      }
    });
  }
  handleRefreshTitle() {
    this.searchInvoiceCompany("");
  }
  handleQuoteData() {
    this.selectedInvoiceTitleData = this.lastInvoce;
  }
  handleChooseInvoiceCompany() {
    let findObj = this.invoiceCompanyList.find(item => item.titleName === this.selectedInvoiceTitleCode);
    this.selectedInvoiceTitleData = findObj ? findObj : {};
  }
  qrCode(url) {
    document.getElementById("qrcode").innerHTML = "";
    let qrcode = new QRCode("qrcode", {
      width: 150, //图像宽度
      height: 150, //图像高度
      colorDark: "#000000", //前景色
      colorLight: "#ffffff", //背景色
      typeNumber: 4,
      correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
    });
    qrcode.clear(); //清除二维码
    qrcode.makeCode(url); //生成另一个新的二维码
  }
  handleDownloadQR() {
    this.downloadIamge();
  }
  downloadIamge() {
    var imgs = document.getElementById("qrcode").getElementsByTagName("img");
    var a = document.createElement("a");
    a.download = "QR" + new Date().getTime() || t("v210801.download-picture-name");
    a.href = imgs[0].src;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.addInvoice();
      } else {
        console.log("error submit!!");
      }
    });
  }
  async init() {
    this.getOrderDetail({
      orderNo: this.orderId
    }).then(data => {
      if (!data.data.receiptAmount) {
        data.data.receiptAmount = data.data.orderAmount;
      }
      this.orderInfo = data.data;
      this.selectedInvoiceTitleData = data.data;
      if (data.data.orderSource === "2") {
        this.getInvoiceInfo({
          orderNo: this.orderId
        }).then(data => {
          this.selectedInvoiceTitleData = data.data || {};
        });
      }
    });
  }
  async addInvoice() {
    console.log(this.selectedInvoiceTitleData, "selectedInvoiceTitleData");
    if (!this.selectedInvoiceTitleData.titleName) {
      this.$message.error(t("service.select-invoice-information"));
      return;
    }
    let params = Object.assign({}, this.invoiceFormData, {
      orderNo: this.orderId.includes("SK") ? "" : this.orderId,
      receiptNo: this.orderInfo.receiptNo,
      payOrderNo: this.collectionDetail.receiptNo,
      titleName: this.selectedInvoiceTitleData.titleName,
      titleTaxId: this.selectedInvoiceTitleData.titleTaxId,
      invoiceAmount: this.orderInfo.receiptAmount || this.collectionDetail.receiptAmount,
      titleAddress: this.selectedInvoiceTitleData.titleAddress,
      titlePhone: this.selectedInvoiceTitleData.titlePhone,
      titleBankName: this.selectedInvoiceTitleData.titleBankName,
      titleBankAccount: this.selectedInvoiceTitleData.titleBankAccount
    });
    this.btnStartLoading();
    this.createInvoice(params)
      .then(() => {
        this.$message.success(
          `${t("service.order")}“${this.orderId || this.collectionDetail.receiptNo}”${t(
            "service.has-make-out-invoice"
          )}`
        );
        if (this.orderId.includes("SK")) {
          this.$router.push(`/finance/invoice-manage`);
        } else {
          this.$router.push(`/service/view/${this.orderId}`);
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleLinkOrderView() {
    let { href } = this.$router.resolve({
      path: `/service/view/${this.orderId}`
    });
    window.open(href, "_blank");
  }
  handleLinkReceiptView() {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${this.orderInfo.receiptNo || this.collectionDetail.receiptNo}`
    });
    window.open(href, "_blank");
  }
}
